export default __webpack_public_path__ + "static/media/9_16-story-ad-combined.273e344d.png";